<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				name="流程"
				label="流程"
				placeholder="选择流程"
				readonly
				value-key="process_name"
				@click="popup.process = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择流程' }]"
			/>
			<van-field
				v-model="form.sqyt"
				rows="2"
				autosize
				label="申请用途"
				type="textarea"
				placeholder="请输入申请用途"
			/>
			<van-field
				v-model="form.start_date"
				name="借用日期"
				label="借用日期"
				placeholder="选择借用日期"
				readonly
				@click="popup.start_date = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择借用日期' }]"
			/>
			<van-field
				v-model="form.end_date"
				name="归还日期"
				label="归还日期"
				placeholder="选择归还日期"
				readonly
				@click="popup.end_date = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择归还日期' }]"
			/>
			<van-field
				v-model="client_id_text"
				name="关联客户"
				label="关联客户"
				placeholder="选择关联客户"
				readonly
				@click="popup.select = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联客户' }]"
			/>
			<van-field
				v-model="form.remark"
				rows="3"
				autosize
				label="备注"
				type="textarea"
				placeholder="请输入备注"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联客户' }]"
			/>

			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="picker.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
		<van-popup v-model="popup.start_date" position="bottom">
			<van-datetime-picker
				type="datetime"
				:min-date="minDate"
				:max-date="maxDate"
				@cancel="popup.start_date = false"
				@confirm="confirmStartTime"
			/>
		</van-popup>
		<van-popup v-model="popup.end_date" position="bottom">
			<van-datetime-picker
				type="datetime"
				:min-date="minDate"
				:max-date="maxDate"
				@cancel="popup.end_date = false"
				@confirm="confirmEndTime"
			/>
		</van-popup>
		<van-popup v-model="popup.select" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="clientList.list"
				@onload="onload"
				@check="check"
				:loading="clientList.loading"
				:finished="clientList.finished"
				value-key="client_name"
			></popup-select>
		</van-popup>
	</div>
</template>

<script>
import { getNowFormatDateTime } from "@/utils/tool";
import popupselect from "@/components/select/index";
import { getList } from "@/api/review";
import { Toast } from "vant";

export default {
	name: "cost",
	components: {
		"popup-select": popupselect
	},
	data() {
		return {
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			client_id: "",
			client_id_text: "",
			date: "",
			minDate: new Date(),
			maxDate: new Date(),
			form: {
				start_date: "",
				end_date: "",
				client_id: "",
				remark: ""
			},
			popup: {
				process: false,
				start_date: false,
				end_date: false,
				select: false
			},
			processList: [],
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25
			}
		};
	},
	mounted() {
		this.getLeaveList();
		this.findDate();
	},
	methods: {
		onSubmit() {
			if (
				this.form.start_date.replace("-", "/") >
				this.form.end_date.replace("-", "/")
			) {
				return Toast.fail("开始日期应小于结束日期");
			}
			this.$emit("sub", {
				requestType: "process_apply",
				process_id: this.process_id,
				apply_data: JSON.stringify(this.form),
				apply_rmb:  "0"
			
			});
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		},
		getLeaveList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
			this.date = "";
		},
		check(value) {
			this.popup.select = false;
			this.client_id_text = value.client_name;
			this.form.client_id = value.client_id;
		},
		onload(search) {
			if (search != undefined) {
				this.clientList.page = 1;
			}
			getList({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(
							res.obj.rows
						);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		confirmStartTime(val) {
			this.form.start_date = getNowFormatDateTime(val);
			this.popup.start_date = false;
		},
		confirmEndTime(val) {
			this.form.end_date = getNowFormatDateTime(val);
			this.popup.end_date = false;
		},
		findDate() {
			let now = new Date();
			now.setDate(now.getDate() + 30);
			this.maxDate = now;
		}
	}
};
</script>